import { Company } from '@/shared/api';

import { ECompanyAdditionalInfoKeys } from '..';

export const serializeCompany = (company?: Company) => {
  if (!company) return null;
  const stepName = company.additionalInfos.nodes.find(
    (info) =>
      (info.key as ECompanyAdditionalInfoKeys) ===
      ECompanyAdditionalInfoKeys.CompanyOnboardingStep,
  )?.value as ECompanyAdditionalInfoKeys;
  return {
    id: company.id,
    step: stepName,
    name: company.registeredBusinessName,
    status: company.currentKYBLevelStatusV2?.status,
    isInternalTransferAllowed: company?.isInternalTransferAllowed,
    registrantId: company?.registrant?.id ?? null,
  };
};
